import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@material-ui/core/SvgIcon';
import { colors } from '../core/colors';
import { IconContainer } from './iconContainer';

export interface LoadingProps {
  fill?: string;
  className?: string;
  size?: number;
}

const StyledSvg = styled(({ ...forwardProps }) => (
  <SvgIcon {...forwardProps} />
))`
  animation: rotate 2s linear infinite;
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loading: React.FunctionComponent<LoadingProps> = ({
  fill = colors.black,
  className,
  size = 22,
}) => (
  <IconContainer
    pathFill={fill}
    className={className}
    width={`${size}px`}
    height={`${size}px`}
  >
    <StyledSvg width={size} height={size} viewBox={`0 0 22 22`}>
      <path
        d="M11,2.08181818 C15.9090909,2.08181818 19.9181818,6.09090909 19.9181818,11 C19.9181818,15.9090909 15.9090909,19.9181818 11,19.9181818 C10.4886364,19.9181818 10.0795455,19.5090909 10.0795455,18.9977273 C10.0795455,18.4863636 10.4886364,18.0772727 11,18.0772727 C14.9068182,18.0772727 18.0772727,14.9068182 18.0772727,11 C18.0772727,7.09318182 14.9068182,3.92272727 11,3.92272727 C10.4886364,3.92272727 10.0795455,3.51363636 10.0795455,3.00227273 C10.0795455,2.49090909 10.4886364,2.08181818 11,2.08181818 Z M7.46136364,17.1363636 C7.89090909,17.3818182 8.05454545,17.9545455 7.78863636,18.3636364 C7.625,18.6704545 7.31818182,18.8340909 6.99090909,18.8340909 C6.84772727,18.8340909 6.68409091,18.7931818 6.54090909,18.7113636 C6.11136364,18.4659091 5.96818182,17.8931818 6.21363636,17.4636364 C6.45909091,17.0340909 7.03181818,16.8704545 7.46136364,17.1363636 Z M4.88409091,14.5795455 C5.15,15.0090909 4.98636364,15.5613636 4.55681818,15.8272727 C4.39318182,15.9090909 4.25,15.95 4.08636364,15.95 C3.75909091,15.95 3.45227273,15.7659091 3.28863636,15.4795455 C3.02272727,15.0295455 3.18636364,14.4772727 3.61590909,14.2113636 C4.04545455,13.9454545 4.61818182,14.1090909 4.88409091,14.5795455 Z M3.00227273,10.0795455 C3.51363636,10.0795455 3.92272727,10.4886364 3.92272727,11 C3.92272727,11.5113636 3.51363636,11.9204545 3.00227273,11.9204545 C2.49090909,11.9204545 2.08181818,11.5113636 2.08181818,11 C2.08181818,10.4886364 2.49090909,10.0795455 3.00227273,10.0795455 Z M4.53636364,6.21363636 C4.96590909,6.45909091 5.12954545,7.01136364 4.86363636,7.46136364 C4.7,7.76818182 4.39318182,7.93181818 4.06590909,7.93181818 C3.92272727,7.93181818 3.75909091,7.89090909 3.61590909,7.80909091 C3.16590909,7.54318182 3.02272727,6.99090909 3.28863636,6.54090909 C3.53409091,6.11136364 4.10681818,5.96818182 4.53636364,6.21363636 Z M7.78863636,3.59545455 C8.05454545,4.04545455 7.89090909,4.59772727 7.46136364,4.86363636 C7.29772727,4.94545455 7.15454545,4.98636364 6.99090909,4.98636364 C6.68409091,4.98636364 6.35681818,4.82272727 6.21363636,4.51590909 C5.94772727,4.08636364 6.09090909,3.51363636 6.54090909,3.26818182 C6.97045455,3.00227273 7.54318182,3.16590909 7.78863636,3.59545455 Z"
        id="path-1"
        width={size}
        height={size}
      />
    </StyledSvg>
  </IconContainer>
);

export { Loading };
